import { render, staticRenderFns } from "./AdminUserListTariffCell.vue?vue&type=template&id=2d88b5b0&scoped=true&lang=pug&"
import script from "./AdminUserListTariffCell.vue?vue&type=script&lang=js&"
export * from "./AdminUserListTariffCell.vue?vue&type=script&lang=js&"
import style0 from "./AdminUserListTariffCell.vue?vue&type=style&index=0&id=2d88b5b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d88b5b0",
  null
  
)

export default component.exports